import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(window.location.hash.replace("#", ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/login");
      return;
    }

    fetch(`${API}/auth/session`, {
      method: "POST",
      credentials: "include",
      headers: { "X-Session-ID": sessionId },
    })
      .then((r) => {
        if (!r.ok) throw new Error("auth failed");
        return r.json();
      })
      .then((user) => {
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { state: { user } });
      })
      .catch(() => navigate("/login"));
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="w-10 h-10 border-2 border-white/20 border-t-[var(--primary)] rounded-full animate-spin" />
        <span className="font-mono-p text-sm text-white/50">Connexion en cours…</span>
      </div>
    </div>
  );
}
